export default __webpack_public_path__ + "static/media/microservices-presentation.005c3fe8.png";